import { Outlet } from 'react-router-dom'

function AccessManageWrapper() {
  return (
    <div className="px-[24px] pb-[24px]">
      <Outlet />
    </div>
  )
}

export default AccessManageWrapper
